import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IPegaDetails,
  ISearchPegaDetails,
} from '../../../services/pega/pegaDetailUserData/pegaDetailUserData.model';
import pegaDetailsService from '../../../services/pega/pegaDetailUserData/pegaDetailUserData.service';

// Asynchronous thunk action

export const searchPegaDetails = createAsyncThunk(
  'searchPegaDetails',
  async (searchParam?: ISearchPegaDetails) => {
    const response = await pegaDetailsService
      .searchPegaDetails(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getPegaDetailsById = createAsyncThunk(
  'getPegaDetailsById',
  async (id: number) => {
    const response = await pegaDetailsService.getPegaDetailsById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const savePegaDetails = createAsyncThunk(
  'savePegaDetails',
  async (data: IPegaDetails) => {
    const response = await pegaDetailsService.savePegaDetails(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deletePegaDetails = createAsyncThunk(
  'deletePegaDetails',
  async (id: number) => {
    const response = await pegaDetailsService.deletePegaDetails(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
